function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import GridUtils from "../GridUtils.js";
import GridSeparatorMouseHandler from "./GridSeparatorMouseHandler.js";
class GridColumnSeparatorMouseHandler extends GridSeparatorMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "hiddenCursor", 'e-resize');
    _defineProperty(this, "defaultCursor", 'col-resize');
    _defineProperty(this, "pointProperty", 'x');
    _defineProperty(this, "userSizesProperty", 'userColumnWidths');
    _defineProperty(this, "visibleOffsetProperty", 'visibleColumnXs');
    _defineProperty(this, "visibleSizesProperty", 'visibleColumnWidths');
    _defineProperty(this, "marginProperty", 'rowHeaderWidth');
    _defineProperty(this, "calculatedSizesProperty", 'calculatedColumnWidths');
    _defineProperty(this, "initialSizesProperty", 'initialColumnWidths');
    _defineProperty(this, "modelIndexesProperty", 'modelColumns');
    _defineProperty(this, "firstIndexProperty", 'firstColumn');
    _defineProperty(this, "treePaddingProperty", 'treePaddingX');
    _defineProperty(this, "getHiddenItems", GridUtils.getHiddenColumns);
    _defineProperty(this, "getNextShownItem", GridUtils.getNextShownColumn);
    _defineProperty(this, "getSeparator", GridColumnSeparatorMouseHandler.getColumnSeparator);
  }
  static getColumnSeparator(gridPoint, metrics, model, theme) {
    if (!theme.allowColumnResize) {
      return null;
    }
    var x = gridPoint.x,
      y = gridPoint.y,
      depth = gridPoint.columnHeaderDepth;
    var modelColumns = metrics.modelColumns;
    var separatorIndex = GridUtils.getColumnSeparatorIndex(x, y, metrics, theme, model);
    if (separatorIndex == null || depth == null) {
      return null;
    }
    var columnIndex = modelColumns.get(separatorIndex);
    if (columnIndex != null) {
      return {
        index: separatorIndex,
        depth
      };
    }
    return null;
  }
  setSize(metricCalculator, modelIndex, size) {
    metricCalculator.setColumnWidth(modelIndex, size);
  }
  resetSize(metricCalculator, modelIndex) {
    metricCalculator.resetColumnWidth(modelIndex);
  }
  updateSeparator(grid, separator) {
    grid.setState({
      draggingColumnSeparator: separator,
      isDragging: separator !== null
    });
  }
}
export default GridColumnSeparatorMouseHandler;
//# sourceMappingURL=GridColumnSeparatorMouseHandler.js.map